export default {
  companyLabel: "회사소개",
  banners: {
    ceo: { title: "CEO 인사말", subtitle: "고객의 문제를 함께 해결하는 기술 파트너" },
    overview: { title: "회사개요", subtitle: "반세기 기술력으로 신뢰를 만듭니다" },
    history: { title: "회사연혁", subtitle: "1975년 창립부터 현재까지, 반세기 성장의 발자취" },
    certifications: { title: "인증현황", subtitle: "국제 표준 인증으로 입증된 품질 경쟁력" },
    location: { title: "찾아오는 길", subtitle: "경기도 시흥시에 위치한 본사 및 공장" },
  },
  historyYearSuffix: "년",
  subNav: [
    { label: "CEO 인사말", to: "/about/ceo", icon: "ri-user-star-line" },
    { label: "회사개요", to: "/about/overview", icon: "ri-building-line" },
    { label: "회사연혁", to: "/about/history", icon: "ri-calendar-check-line" },
    { label: "인증현황", to: "/about/certifications", icon: "ri-shield-check-line" },
    { label: "찾아오는 길", to: "/about/location", icon: "ri-map-pin-2-line" },
  ],
  ceo: {
    name: "이남재",
    title: "대표이사",
    greeting: "고객의 문제를 함께 해결하는 기술 파트너가 되겠습니다.",
    body: "한국고무공업주식회사 홈페이지를 방문해 주셔서 진심으로 감사드립니다.\n\n저희 한국고무공업은 1975년 창립 이래 반세기 가까이 오직 고무제품 제조 한 길을 걸어왔습니다. '고무제품에 문제가 있으신가요? 저희가 해결해 드리겠습니다.'라는 신념 아래, 단순한 부품 공급을 넘어 고객의 기술적 난제를 함께 분석하고 최적의 솔루션을 제안하는 기술 파트너로 성장해 왔습니다.\n\n압축성형(Compression Molding) 분야에서 축적된 50년의 기술력과 노하우는 품질과 신뢰의 밑거름입니다. EPDM, NBR, CR, SBR, FKM, 실리콘고무 등 다양한 고무 소재를 다루며, 자동차·중공업·전기전자·화학·조선 등 전 산업 분야에 걸쳐 고객 맞춤형 고무 부품을 공급하고 있습니다.\n\n저희는 앞으로도 지속적인 기술 혁신과 품질 향상을 통해, 고객 여러분의 성공을 함께 만들어가는 든든한 동반자가 되겠습니다.\n\n감사합니다.",
    signature: "한국고무공업주식회사 대표이사 이남재",
  },
  overview: {
    name: "한국고무공업주식회사",
    enName: "HANKUK RUBBER TECH. CO.,LTD.",
    established: "1975년 4월",
    ceo: "이남재",
    employees: "85명",
    factoryArea: "6,600㎡",
    annualRevenue: "연 120억",
    businessType: "고무제품 제조 및 도소매",
    companyInfoTitle: "기업 정보",
    facilityTitle: "주요 생산설비",
    productsTitle: "주요 제품",
    coreValuesTitle: "핵심 가치",
    visionLabel: "VISION",
    missionLabel: "MISSION",
    rows: [
      { label: "회사명", value: "한국고무공업주식회사" },
      { label: "영문명", value: "HANKUK RUBBER TECH. CO.,LTD." },
      { label: "설립일", value: "1975년 4월" },
      { label: "대표이사", value: "이남재" },
      { label: "업종", value: "고무제품 제조 및 도소매" },
    ],
    mainProducts: [
      "산업용 O-Ring",
      "산업용 다이아프램",
      "맞춤형 다이아프램",
      "열교환기용 가스켓",
      "자동차용 고무 부츠 / 벨로우즈",
      "실리콘 밸브 시트 / 링",
      "정밀 고무부품",
      "식품공정 제품",
      "흡착 컵",
    ],
    facilities: [
      { name: "압축성형 프레스", spec: "50톤~1200톤", count: "24대" },
      { name: "고무 혼련기", spec: "Kneader", count: "1대" },
      { name: "OPEN ROLLER", spec: "14inch×16inch", count: "2대" },
      { name: "물성 시험기", spec: "인장·경도·노화", count: "6종" },
    ],
    vision: "고객의 기술적 문제를 해결하는 대한민국 대표 고무제품 솔루션 파트너",
    mission: "압축성형 고무 기술의 혁신을 통해 산업 발전에 기여한다",
    coreValues: [
      { label: "품질 우선", desc: "완벽한 품질 없이는 신뢰도 없다" },
      { label: "기술 혁신", desc: "끊임없는 연구개발로 한계를 넘어선다" },
      { label: "고객 동행", desc: "고객의 문제가 곧 우리의 과제다" },
      { label: "신뢰 경영", desc: "50년의 역사 위에 미래를 약속한다" },
    ],
    detail: "상세 보기",
  },
  history: [
    { year: 1975, month: 0, content: "한국화학고무 창립" },
    { year: 1978, month: 0, content: "열교환기용 Plate Gasket 개발" },
    { year: 1980, month: 0, content: "트랙터용 부품 개발" },
    { year: 1991, month: 0, content: "국민차 개발사업 참여" },
    { year: 2002, month: 0, content: "이전 (사회공단) 및 상호변경 (한국고무공업)" },
    { year: 2002, month: 0, content: "하드디스크용 Crash Stop 개발 (삼성전자 向)" },
    { year: 2008, month: 0, content: "ISO 9001 인증 획득" },
    { year: 2011, month: 0, content: "대형 수문용 Packing 개발" },
    { year: 2012, month: 0, content: "Panama 운하 Valve Seal 납품" },
    { year: 2014, month: 0, content: "TS 16949(現 IATF16949) 인증" },
    { year: 2018, month: 0, content: "전기자동차 파워팩용 방수 가스켓 양산" },
  ],
  certifications: [
    {
      name: "ISO 9001",
      fullName: "품질경영시스템",
      year: "1998년 최초 획득",
      desc: "국제표준화기구(ISO)가 제정한 품질경영시스템 국제규격으로, 고객에게 일관된 품질의 제품과 서비스를 제공할 수 있는 경영시스템을 갖추었음을 인증합니다.",
      icon: "ri-shield-check-line",
    },
    {
      name: "IATF 16949",
      fullName: "자동차 품질경영시스템",
      year: "2008년 최초 획득",
      desc: "자동차 산업에 특화된 품질경영시스템 국제규격으로, 자동차 부품 제조사에게 요구되는 엄격한 품질관리 기준을 충족함을 인증합니다.",
      icon: "ri-car-line",
    },
    {
      name: "연구개발전담부서",
      fullName: "기업부설연구소 인증",
      year: "2013년 획득",
      desc: "한국산업기술진흥협회(KOITA)가 인증하는 기업부설연구소로, 체계적인 연구개발 역량과 전담 인력을 보유하고 있음을 공식 인증합니다.",
      icon: "ri-flask-line",
    },
  ],
  location: {
    address: "경기도 시흥시 옥구천서로 237번길 36",
    postalCode: "15048",
    tel: "031-434-0341",
    fax: "031-434-0340",
    email: "hkrubbert@naver.com",
    mapEmbed: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3170.597620348084!2d126.738!3d37.375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b7a1c0a1c0a1b%3A0x0!2z6rK96riw64-EIOyLnO2dkOyLnCDsmKXqtazsspzshJzroZwgMjM367iY6ri4IDM2!5e0!3m2!1sko!2skr!4v1710000000000" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
    subway: "수도권 전철 4호선 정왕역 (도보 25분 / 택시 5분)",
    bus: "7번, 22번, 31-3번, 61번 버스 정왕동주민센터 하차 (도보 5분)",
    parking: "공장 내 주차 가능 (승용차 30대, 대형트럭 5대 동시 주차)",
    contactTitle: "연락처 및 주소",
    transportTitle: "교통편 안내",
    mapTitle: "지도",
    labels: {
      address: "주소",
      tel: "전화",
      fax: "팩스",
      email: "이메일",
      subway: "지하철",
      bus: "버스",
      parking: "주차",
    },
  },
  coming: {
    title: "회사소개 페이지는 곧 공개됩니다",
    subtitle: "연혁 타임라인, 오시는 길, 회사 비전 등 풍부한 회사 정보를 곧 만나보실 수 있습니다.",
    description: "다음 단계에서 이 페이지를 완성해 드릴게요.",
  },
};